// extracted by mini-css-extract-plugin
export var actions = "_1s-0";
export var actionsContainer = "_1s-7";
export var border = "_1s-1";
export var childFullHeight = "_1s-f";
export var collapse = "_1s-2";
export var content = "_1s-a";
export var contentChild = "_1s-e";
export var fullscreen = "_1s-c";
export var hasLeftRadius = "_1s-k";
export var headerContainer = "_1s-3";
export var headerRow = "_1s-5";
export var hidePadding = "_1s-b";
export var navCollapsedGap = "_1s-l";
export var noScrollX = "_1s-m";
export var noScrollY = "_1s-n";
export var noTopPadding = "_1s-i";
export var optOutTopPadding = "_1s-d";
export var pageMain = "_1s-j";
export var pageOuter = "_1s-g";
export var pagePadding = "_1s-8";
export var pageScroll = "_1s-9";
export var profile = "_1s-o";
export var profileContainer = "_1s-p";
export var profileImage = "_1s-q";
export var profileMain = "_1s-r";
export var profileSubtitle = "_1s-t";
export var profileTitle = "_1s-s";
export var showLeftPadding = "_1s-h";
export var tabsPortalSlot = "_1s-6";
export var tabsWrapper = "_1s-4";
export var title = "_1s-u";